export interface ContentProps {
  smallText: string;
  bigText: string;
}

export const Content = ({ smallText, bigText }: ContentProps) => (
  <div className="flex w-1/2 flex-col items-center">
    <div className="text-size-body3">{smallText}</div>
    <div className="text-size-h3 mt-0.5">{bigText}</div>
  </div>
);
